import { render, staticRenderFns } from "./FieldsSettings.vue?vue&type=template&id=b826ede2&"
import script from "./FieldsSettings.vue?vue&type=script&lang=js&"
export * from "./FieldsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports